require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./scurit-sur-le-campus-1-9-1.json") })
        }
      }, "path---scurit-sur-le-campus-1-9-1");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---scurit-sur-le-campus-1-9-1!./.cache/json/scurit-sur-le-campus-1-9-1.json
// module id = 566
// module chunks = 231608221292675